"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OptionGroup = void 0;
const React = __importStar(require("react"));
const styles = __importStar(require("./OptionGroup.css"));
const constants_1 = require("../../constants");
const Option_1 = __importDefault(require("./Option"));
const constants_2 = require("../../search/constants");
const OptionGroup = (props) => {
    const { id, disabled, options, multiple, handleSelected, showAny, anyOptionLabel, anyChecked } = props;
    const componentClassName = `${constants_1.ANG_CSS_PREFIX}-option`;
    const groups = options.map(o => o.group).filter((val, index, all) => all.indexOf(val) === index);
    const anyOpt = {
        checked: anyChecked,
        disabled,
        group: '',
        key: constants_2.SEARCH_ANY_OPTION_KEY,
        label: anyOptionLabel,
    };
    const renderOptions = (opts) => opts.map(opt => (React.createElement("li", { key: `${id}-ul-li-opt-${opt.key}`, className: `${styles.option} ${componentClassName}-group-list-group-option` },
        React.createElement(Option_1.default, { disabled: opt.disabled, id: `${id}-ul-${opt.key}`, key: `${id}-ul-li-opt-${opt.key}`, multiple: multiple, value: opt.key, option: opt, onCheck: handleSelected }))));
    return (React.createElement("div", { className: `${componentClassName} ${styles['option-group']} ${disabled ? 'disabled' : ''}`, "data-test-id": 'option-group', "aria-label": id, id: id },
        React.createElement("ul", { className: `${styles['group-list']} ${componentClassName}-group-list`, id: `${id}-group-list`, "data-test-id": `option-group-list` },
            showAny && (React.createElement("li", { key: `${id}-ul-li-opt-${anyOpt.key}`, className: `${styles.option} ${componentClassName}-group-list-group-option` },
                React.createElement(Option_1.default, { disabled: anyOpt.disabled, id: `${id}-ul-${anyOpt.key}`, key: `${id}-ul-li-opt-${anyOpt.key}`, multiple: multiple, value: anyOpt.key, option: anyOpt, onCheck: handleSelected }))),
            groups.map(group => {
                if (group !== '') {
                    return (React.createElement("li", { key: group + '_li', "data-test-id": `${id}-group-list-group`, className: `${styles['group-list-group']} ${componentClassName}-group-list-group` },
                        React.createElement("span", { key: group + '_span', className: `${styles.label} ${componentClassName}-group-list-group-label` }, group),
                        React.createElement("ul", { key: group + '_ul', "data-test-id": `option-group-group-list`, role: 'group', className: `${styles['option-list']} ${componentClassName}-group-list-group-option-list` }, renderOptions(options.filter(o => o.group === group)))));
                }
                else {
                    return renderOptions(options.filter(o => o.group === group));
                }
            }))));
};
exports.OptionGroup = OptionGroup;
exports.default = exports.OptionGroup;
